
















import Vue from 'vue';
import { mapState, mapActions } from '@/storeutils';
import store, { IStore, IBusinessSummary, actions } from '@/Store';
import isEmpty from 'lodash/isEmpty';
import BaseMallOverviewDirectory from './BaseMallOverviewDirectory.vue';
import CategorySelector from '@/components/CategorySelector.vue';
import gql from 'graphql-tag';

interface IBusinessCategoryMap {
  [id: string]: { name: string };
}

interface IBusinessCategoryResult {
  id: string;
  name: string;
}

interface IBusinessResult {
  id: string;
  name: string;
  active: boolean;
  unit?: string;
  category?: IBusinessCategoryResult;
}

interface IMallDirectoryResult {
  findMallByID: {
    businesses: {
      data: IBusinessResult[];
      beforeCursor?: string;
      afterCursor?: string;
    };
  };
}

export default Vue.extend({
  name: 'MallOverviewDirectory',
  props: {
    mallId: String,
  },
  data() {
    return {
      selectedCategories: [] as string[],
      search: '',
      businesses: [] as IBusinessResult[],
    };
  },
  computed: {
    // For showing only categories applicable to this mall's list of businesses
    displayedCategories(): IBusinessCategoryMap {
      if (isEmpty(this.businesses)) {
        return {};
      }

      const displayedCats: IBusinessCategoryMap = {};

      for (const { category } of this.businesses) {
        if (category) {
          displayedCats[category.id] = { name: category.name };
        }
      }

      return displayedCats;
    },
    filteredBusinesses(): IBusinessSummary[] {
      const businesses = this.businesses || {};

      const filteredBiz = !this.selectedCategories.length
        ? businesses
        : businesses.filter(({ category }) => {
            return category
              ? this.selectedCategories.includes(category.id)
              : false;
          });

      // Convert into array format so that it's easier for data iterator to digest

      const filteredBizArr: IBusinessSummary[] = [];

      for (const biz of Object.values(filteredBiz)) {
        filteredBizArr.push(biz);
      }

      return filteredBizArr;
    },
  },
  components: {
    BaseMallOverviewDirectory,
    CategorySelector,
  },
}).extend({
  apollo: {
    businesses: {
      query: gql`
        query getMallDirectory($mallID: ID!) {
          findMallByID(id: $mallID) {
            id: _id
            businesses(_size: 1000) {
              data {
                id: _id
                name
                active
                level
                unit
                category {
                  id: _id
                  name
                }
              }
            }
          }
        }
      `,
      variables() {
        return {
          mallID: this.mallId,
        };
      },
      update(data: IMallDirectoryResult) {
        const resultRoot = data.findMallByID;
        return (resultRoot && resultRoot.businesses.data) || [];
      },
      skip(): Boolean {
        return !this.mallId;
      },
    },
  },
});
